import { type FetchEventSourceInit } from '@microsoft/fetch-event-source'

import { type CoreBundleItemPayload } from '@flecto/types'

import { getApiEventSourceClient } from '../../../services/getApiEventSourceClient'

const generateQueryString = (items: Array<CoreBundleItemPayload>): string => {
  if (!items || items.length === 0) return ''

  const queryParams = items.flatMap((item) => [
    `items[]id=${item.item_id}`,
    `items[]quantity=${item.quantity}`,
  ])

  return queryParams.join('&')
}

/**
 * Get bundle description generated by AI
 *
 * @endpoint GET /api/ai/bundle/description/generate
 * @scope shared
 * @see https://flecto.dev/api-16661798
 */
export function getAIBundleDescription(
  items: Array<CoreBundleItemPayload>,
  options?: GetAIBundleDescriptionOptions
) {
  const eventSource = getApiEventSourceClient()
  const queryString = generateQueryString(items)
  let path = `api/ai/bundle/description/generate?${queryString}`
  
  if (options?.wait) {
    path = `${path}&wait=${options.wait}`
  }

  return eventSource.get(path, options)
}

export type GetAIBundleDescriptionOptions = FetchEventSourceInit & {
  wait?: number
}
